import React from 'react';
import { getUserSelectedPlan, getUser } from '../data/db';
import { useNavigate } from 'react-router-dom';

export default function Checkout() {
  const plan = getUserSelectedPlan('child-1');
  const user = getUser('child-1');
  const navigate = useNavigate();

  if (!plan) {
    return (
      <div className="card">
        <h2>No plan selected</h2>
        <p className="meta">Choose a subscription plan first.</p>
      </div>
    );
  }

  return (
    <div>
      <h1>Checkout</h1>
      <div className="card">
        <h3>{plan.name}</h3>
        <div style={{fontSize:20,fontWeight:800}}>{plan.priceLabel}</div>
        <p className="meta">{plan.description}</p>

        <div style={{marginTop:12}}>
          <strong>Subscriber:</strong> {user.name}
        </div>

        <div style={{marginTop:12}}>
          <p><em>Payment gateway will be connected later. This is a placeholder checkout workflow.</em></p>
          <button className="btn" onClick={() => { alert('Payment flow placeholder — integrate gateway later.'); navigate('/progress'); }}>Confirm (placeholder)</button>
        </div>
      </div>
    </div>
  );
}
